import React from "react";
// import AuthLayout from "../../components/";
import {
  Button,
  Col,
  Form,
  Image,
  Input,
  Layout,
  Row,
  Typography
} from "antd";
import { FiMail } from "react-icons/fi";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import { Post } from "../../config/api/post";
import { AUTH } from "../../config/constants/api";
import { ImageUrl } from "../../helpers/Function";




function ForgetPassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
// import router from "next/router";
const onFinish = (values) => {
  
  console.log("Success:", values);
  setLoading(true);
  

  Post(AUTH.emailCode, values)
    .then((response) => {
      setLoading(false);
      if (response?.data) {
        swal("Success", response?.data?.message, "success");
        navigate("/forgot-password-2", { replace: true,state:values });
      } else {
        swal("Oops!", response?.data?.message || response?.response?.data?.message, "error");
      }
    })
    .catch((e) => {
      console.log(e,"ww")
      swal("Oops!","internal server error", "error");
      setLoading(false);
    });
};
const onFinishFailed = (errorInfo) => {
  console.log("Failed:", errorInfo);
};


  return (
     
    <Layout className="AuthBackground" style={{ minHeight: "100vh" }}>
      <Row>
        <Col xs={0} sm={0} md={14}>
        <div className="authImageBox">
          <Row style={{width:'100%',paddingRight:'20px'}} gutter={40}>
            <Col xs={0} sm={6} md={6}>
             <div className="authImage1" />
            </Col>
            <Col xs={0} sm={6} md={6}>
            <div className="authImage2" />
            </Col>
            <Col xs={0} sm={12} md={12}>
            <div className="authImage3" />
            </Col>
          </Row>
          </div>
        </Col>

        <Col xs={24} md={10}>
          <div className="authFormBox">
            <Row style={{ width: "100%", justifyContent: "center" }}>
              <Col xs={20} md={20} className="formWrap">
                <Row style={{ width: "100%", textAlign: "center" }}>
                  <Col xs={24} md={0}>
                    <Image
                      src={ImageUrl('logo.png')}
                      style={{ maxWidth: "200px" }}
                      alt=""
                      preview={false}
                    />
                  </Col>
                </Row>

                <Typography.Title
                  className="fontFamily1"
                  style={{ fontSize: "30px", color: "#333d47" }}
                >
                  Forgot Password
                </Typography.Title>
                <Typography.Text
                  className="fontFamily1"
                  style={{ fontSize: "14px", color: "#333d47" }}
                >
                  Enter your email address to receive a verification code
                </Typography.Text>
                <br /> <br /><br />
                <Form
                  layout="vertical"
                  name="basic"
                  className="loginForm"
                  labelCol={{
                    span: 0,
                  }}
                  wrapperCol={{
                    span: 24,
                  }}
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                >
                  <Form.Item
                    label="Email Address*"
                    name="email"
                    rules={[
                      {
                        type: "email",
                        message: "Please input valid email!",
                        // warningOnly: true,
                      },
                      {
                        required: true,
                        message: "Please input your email!",
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder="Enter Email Address"
                      className="AuthFormInput"
                      prefix={<FiMail />}
                    />
                  </Form.Item>

                  
                  

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="loginButton"
                      // onClick={() => navigate("/forgot-password-2")}
                    >
                      {loading ? "Loading..." : "Continue"}
                    </Button>
                  </Form.Item>
                </Form>
                <Row>
                    <Col xs={24} md={12}>
                      <Button
                        type="link"
                        style={{
                    
                          color: "white",
                          fontWeight: "bold",
                          textDecoration: "underline",
                          fontSize: "14px",
                        }}
                        onClick={() => navigate("/signin")}
                      >
                        <p className="fontFamily1" style={{ margin: 0 }}>
                          Back to Login
                        </p>
                      </Button>
                    </Col>
                  </Row>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Layout>
  );
}

export default ForgetPassword;
